import React, {useContext, useEffect, useState} from 'react'
import {AutoComplete, Form} from "antd";
import {PurchaseContext} from "../../../context/PurchaseContext";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";


const {Option} = AutoComplete

const PurchaseSupplier = ({rowIndex}) => {
    const [form] = Form.useForm()
    const {suppliers, purchaseItems} = useContext(PurchaseContext)
    const [supplierData, setSupplierData] = useState([])
    const [purchaseItemList, setPurchaseItemList] = purchaseItems
    const [supplierList] = suppliers

    useEffect(() => {
        const supps = supplierList.map(item => {
            return {
                value: item.id,
                text: item.name
            }
        })
        setSupplierData(supps)
    }, [supplierList])

    const handleSupplierChange = (val, {key}) => {
        const newList = replaceIndexAt(
            purchaseItemList,
            {
                ...purchaseItemList[rowIndex],
                supplier: key
            },
            rowIndex
        )
        setPurchaseItemList(newList)
    }

    return(
        <React.Fragment>
            <Form
            form={form}
            >
                <Form.Item
                    style={{marginBottom: 0}}
                    name={'purchaseSupplier'}
                    rules={[
                        {required: true, message: 'Bu Alan Zorunludur'},
                        () => ({
                            validator(rule, value) {
                                let hasValue = supplierData.filter(supplier => supplier.text.toLocaleLowerCase() === value.toLocaleLowerCase())
                                if (value && hasValue.length > 0) {
                                    handleSupplierChange(true, {key: hasValue[0].value})
                                    return Promise.resolve();
                                }

                                return Promise.reject('Lütfen Geçerli Bir Değer Giriniz');
                            },
                        }),
                    ]}
                >
                    <AutoComplete
                        style={{minWidth: '100px'}}
                        filterOption={(inputValue, option) =>
                            option.value.toLocaleLowerCase().indexOf(inputValue.toLocaleLowerCase()) !== -1
                        }
                    >
                        {
                            supplierData.map(item => <Option key={item.value} value={item.text} />)
                        }
                    </AutoComplete>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default PurchaseSupplier